import Vue from "vue"
import Router from "vue-router"
import { isAuth, SUPER_ROLE } from "../utils/utils"

//authentication
import Login from "../view/Login"
import Signup from "../view/Signup"
import ResetPassword from "../view/ResetPassword"

//private page
//import Home from "../view/private-page/Home";
import ChooseModule from "@/view/private-page/organization/admin/module/ChooseModule"

//router-modules
import CloudRouter from "@/router/router-modules/cloud-router"
import PublicRouter from "@/router/router-modules/public-route"
import SettingRouter from "@/router/router-modules/setting-router"
import FlowChartRouter from "@/router/router-modules/flowchart-router"
import DocumentRouter from "@/router/router-modules/documents-router"
import ProjectRouter from "@/router/router-modules/project-router"
import OrganizationRouter from "@/router/router-modules/organization-router"
import UsersRouter from "@/router/router-modules/users-router"
import DatasRouter from "@/router/router-modules/datas-router"
import BrowseRouterExp from "@/router/router-modules/browse-router"
import TicketingRouter from "@/router/router-modules/ticketing-router"
import wizardRouter from "@/router/router-modules/wizard-router"
import Home from "@/modules/home"

Vue.use(Router)

const protected_routes = [
	"home",
	"cloud",
	"mail",
	"settings",
	"users",
	"datas",
	"editsaved",
	"documents",
	"projects",
	"projects.my-projects",
	"projects.my-projects",
	"documents.flowchart-editsaved",
	"documents.flowchart",
	"documents.folders",
	"documents.doc-archive",
	"documents.flowchartedit",
	"documents.all-docs",
	"browse",
	"browse.folders",
	"browse.documents",
	"ticketing",
	"wizards"
]
const auth_routes = ["login", "signup", "resetpassword"]

const fulladmin_routes = [
	"settings.sitesettings",
	"settings.mailtest",
	"users",
	"datas",
	"flowcharts",
	"flowchart",
	"documents.flowchart-editsaved",
	"projects.my-projects",
	"projects.school-projects",
	"documents.flowchartedit",
	"documents.all-docs",
	"documents.folders",
	"documents.doc-archive",
	"subscriptions",
	"editsaved",
	"documents",
	"wizards"
]

const public_routes = ["public", "public.home", "public.demo"]

const admin_routes = ["organizations-settings", "school_subscriptions-settings"]

const router = new Router({
	// mode: "history",
	routes: [
		{
			path: "/home",
			name: "home",
			component: Home,
			props: true
		},
		{
			path: "/login",
			name: "login",
			component: Login
		},
		{
			path: "/login/:purpose/:conf_code",
			name: "login",
			component: Login
		},
		
		{
			path: "/signup",
			name: "signup",
			component: Signup
		},
		{
			path: "/signup/:name/:id",
			name: "signup",
			component: Signup
		},
		{
			path: "/resetpassword",
			name: "resetpassword",
			component: ResetPassword
		},
		{
			path: "/resetpassword/:conf_code",
			name: "resetpassword",
			component: ResetPassword
		},
		{
			path: "/router-modules",
			name: "chooseModule",
			component: ChooseModule
		},

		CloudRouter,
		SettingRouter,
		OrganizationRouter,
		UsersRouter,
		DatasRouter,
		FlowChartRouter,
		DocumentRouter,
		ProjectRouter,
		BrowseRouterExp,
		TicketingRouter,
		// PublicRouter,
		wizardRouter
	]
})

router.beforeEach((to, from, next) => {
	var route = ""
	if (to.name) {
		var r = to.name.split(".")
		route = r[0]
	} else {
		route = to.path.split("/")[1]
	}

	if (protected_routes.includes(route)) {
		isAuth()
			.then(res => {
				var superAdmin = res.auth.data.organization.id == 1

				if (!res.auth.data.approved) {
					localStorage.removeItem("JWT")
					next()
				}

				if (!res.auth.data.organization.confirmed) {
					if (route != "settings") next({ name: "organizations-settings" })
				}

				for (let role of res.auth.data.roles) {
					if (SUPER_ROLE.indexOf(role.name) > -1) {
						router.app.$store.commit("user/LOGIN_SUCCESS", res.auth.data)
						router.app.$store.commit("user/USER", res.auth.data)
					}
				}
				/*
				var permissions = res.auth.data.permissions;
				for(let permission of permissions){
					if(permission.module.name == route){
						router.app.$store.commit('user/LOGIN_SUCCESS',res.auth.data)
						router.app.$store.commit('user/USER', res.auth.data)
						next()
						return;
					}
				}
				*/

				if ((!superAdmin && fulladmin_routes.includes(route)) || (superAdmin && admin_routes.includes(route))) {
					next({ name: "home" })
				} else {
					//special redirects

					if (!superAdmin && to.name === "projects.school-projects") {
						next({ name: "projects.my-projects" })
					} else {
						next()
					}
				}
			})
			.catch(() => {
				router.app.$store.commit("user/AUTH_FAILED")
				next({ name: "login", path: "/login", params: { auth: false } })
			})
	} else if (auth_routes.includes(to.name)) {
		isAuth()
			.then(res => {
				router.app.$store.commit("user/LOGIN_SUCCESS", res.auth.data)
				if (to.params.purpose == "school") next()
				else {
					if (res.auth.data.approved) next({ name: "home", path: "/home" })
					else {
						localStorage.removeItem("JWT")
						next()
					}
				}
			})
			.catch(err => {
				router.app.$store.commit("user/AUTH_FAILED")
				next()
			})
	} else if (public_routes.includes(route)) {
		next()
	} else {
		isAuth()
			.then(res => {
				router.app.$store.commit("user/LOGIN_SUCCESS", res.auth.data)
				router.app.$store.commit("user/USER", res.auth.data)
				next({ name: "home" })
			})
			.catch(err => {
				router.app.$store.commit("user/AUTH_FAILED", err)
				next({ name: "login", params: { auth: false } })
			})
	}
})

export default router
